/**
 * Numeric source of truth for the z-index scale.
 *
 * MUST stay in sync with `zIndex.module.scss` — that file is the SCSS-side copy, and its `:export`
 * block only resolves under webpack. Jest maps `*.scss` to `identity-obj-proxy`, so reading a value
 * through the module returns the KEY (`'overlay'`), and `Number(...)` of it is `NaN`. Any z-index
 * arithmetic in TS therefore reads from here, never from the stylesheet.
 */ export const zIndexScale = {
    page: 300,
    popover: 550,
    nativeSafeAreaMask: 600,
    overlay: 1300,
    portalledCalendar: 1500,
    inlinePicker: 100000,
    globalLoader: 200000,
    nativeSplash: 200001
};
